import { PlanBenefitVariantTypes } from '@/components/PlanBenefitTile/planBenefitTypes';

export const SpeedIcon = ({
  variant,
}: {
  variant: PlanBenefitVariantTypes;
}) => {
  switch (variant) {
    case 'color':
      return (
        <svg
          width="14"
          height="21"
          viewBox="0 0 14 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.1975 1.07895L0.355538 12.3529C0.196772 12.5315 0.344852 12.8155 0.584529 12.7895L5.47881 12.2537C5.69254 12.2292 5.84214 12.4567 5.73681 12.646L1.52339 20.0989C1.37378 20.3615 1.71269 20.6256 1.93557 20.4225L13.6248 9.47526C13.7942 9.31649 13.695 9.03865 13.466 9.01881L7.88626 8.61578C7.70765 8.60052 7.59315 8.41732 7.66338 8.24787L10.6341 1.35832C10.7532 1.08048 10.3914 0.851488 10.1914 1.08048H10.196L10.1975 1.07895Z"
            fill="#00B2A9"
          />
          <path
            d="M1.75103 20.7389C1.64111 20.7389 1.52814 20.7038 1.43349 20.6244C1.23046 20.4656 1.1755 20.1969 1.30373 19.9679L5.51715 12.5151L0.609129 13.0265C0.399985 13.0509 0.196947 12.9425 0.0977177 12.7532C-0.00151142 12.5639 0.027494 12.341 0.167941 12.1823L10.0084 0.915953C10.1779 0.722075 10.4511 0.682383 10.6694 0.821304C10.8877 0.960224 10.9671 1.21822 10.8679 1.4579L7.88644 8.34897L13.4799 8.77642C13.6829 8.79169 13.857 8.91992 13.9272 9.1138C13.9974 9.30768 13.947 9.51682 13.7929 9.66032L2.09909 20.5999C1.99986 20.6946 1.87621 20.7389 1.75103 20.7389ZM5.50647 12.0006C5.67592 12.0006 5.83926 12.0846 5.93391 12.2296C6.03772 12.3929 6.04841 12.5975 5.95376 12.7608L1.74034 20.2137L13.4555 9.28783L7.86659 8.8558C7.70324 8.84512 7.55364 8.752 7.46357 8.61308C7.37961 8.46958 7.36434 8.29554 7.42846 8.14594L10.4053 1.25944L10.1916 1.08083L10.3809 1.24417L0.543485 12.5166L5.45151 12.0052H5.50647V12.0006Z"
            fill="#27282E"
          />
        </svg>
      );
    case 'grey':
      return (
        <svg
          width="14"
          height="20"
          viewBox="0 0 14 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1976 0.328952L0.355575 11.6029C0.196808 11.7815 0.344888 12.0655 0.584565 12.0395L5.47885 11.5037C5.69257 11.4792 5.84218 11.7067 5.73684 11.896L1.52342 19.3489C1.37382 19.6115 1.71272 19.8756 1.93561 19.6725L13.6248 8.72526C13.7942 8.56649 13.695 8.28865 13.466 8.26881L7.8863 7.86578C7.70769 7.85052 7.59319 7.66732 7.66341 7.49787L10.6342 0.60832C10.7533 0.330479 10.3915 0.101488 10.1915 0.330479H10.196L10.1976 0.328952Z"
            fill="#424242"
          />
          <path
            d="M1.75103 19.9889C1.64112 19.9889 1.52815 19.9538 1.4335 19.8744C1.23046 19.7156 1.1755 19.4469 1.30374 19.2179L5.51716 11.7651L0.609135 12.2765C0.39999 12.3009 0.196952 12.1925 0.0977234 12.0032C-0.0015057 11.8139 0.0274997 11.591 0.167947 11.4323L10.0084 0.165953C10.1779 -0.0279254 10.4511 -0.067617 10.6694 0.0713037C10.8877 0.210224 10.9671 0.46822 10.8679 0.707896L7.88644 7.59897L13.4799 8.02642C13.6829 8.04169 13.857 8.16992 13.9272 8.3638C13.9974 8.55768 13.947 8.76682 13.7929 8.91032L2.0991 19.8499C1.99987 19.9446 1.87621 19.9889 1.75103 19.9889ZM5.50647 11.2506C5.67592 11.2506 5.83927 11.3346 5.93392 11.4796C6.03773 11.6429 6.04841 11.8475 5.95377 12.0108L1.74035 19.4637L13.4555 8.53783L7.8666 8.1058C7.70325 8.09512 7.55364 8.002 7.46357 7.86308C7.37961 7.71958 7.36435 7.54554 7.42846 7.39594L10.4053 0.509438L10.1916 0.330826L10.3809 0.494172L0.543491 11.7666L5.45151 11.2552H5.50647V11.2506Z"
            fill="#27282E"
          />
        </svg>
      );
  }
};
